import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import AssetsPage from './components/pages/AssetsPage';
import ActivityPage from './components/pages/ActivityPage';
import EarnPage from './components/pages/EarnPage';
import ExplorePage from './components/pages/ExplorePage';
import SettingsPage from './components/pages/SettingsPage';
import LiquidStakingPage from './components/pages/LiquidStakingPage';
import userProfilesData from './data/userProfiles.json';

const AppContent = () => {
  const [currentProfile, setCurrentProfile] = useState('nICPWithWithdrawals');
  const location = useLocation();
  const navigate = useNavigate();

  const profiles = userProfilesData.profiles;
  const profileKeys = Object.keys(profiles);
  
  const getCurrentPageName = () => {
    switch (location.pathname) {
      case '/':
      case '/assets':
        return 'Assets';
      case '/activity':
        return 'Activity';
      case '/earn':
        return 'Earn & Rewards';
      case '/liquid-staking':
        return 'ICP Liquid Staking';
      case '/explore':
        return 'Explore';
      case '/settings':
        return 'Settings';
      default:
        return 'Assets';
    }
  };

  return (
    <div className="app">
      <Sidebar currentPage={getCurrentPageName()} />
      <div className="main-content">
        <Header 
          currentProfile={currentProfile}
          setCurrentProfile={setCurrentProfile}
          profiles={profiles}
          profileKeys={profileKeys}
          currentPage={getCurrentPageName()}
        />
        <div className="page-content">
          <Routes>
            <Route path="/" element={<AssetsPage profileData={profiles[currentProfile]} />} />
            <Route path="/assets" element={<AssetsPage profileData={profiles[currentProfile]} />} />
            <Route path="/activity" element={<ActivityPage profileData={profiles[currentProfile]} />} />
            <Route path="/earn" element={<EarnPage profileData={profiles[currentProfile]} navigate={navigate} />} />
            <Route path="/liquid-staking" element={<LiquidStakingPage profileData={profiles[currentProfile]} navigate={navigate} />} />
            <Route path="/explore" element={<ExplorePage profileData={profiles[currentProfile]} />} />
            <Route path="/settings" element={<SettingsPage profileData={profiles[currentProfile]} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
